import { render, staticRenderFns } from "./ReminderRuleCreate.vue?vue&type=template&id=352f0e9e&scoped=true&"
import script from "./ReminderRuleCreate.vue?vue&type=script&lang=js&"
export * from "./ReminderRuleCreate.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ReminderRuleCreate.vue?vue&type=style&index=1&id=352f0e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f0e9e",
  null
  
)

export default component.exports